// Phosphor Duotone icons (MIT, @phosphor-icons/react), bundled at build time.
// The design system names icons the way Iconify does ("briefcase",
// "identification-badge"); this maps those names to the React components so
// moduleMap.js and screens can keep using them, with no network fetch.
import React from 'react';
import {
  ArrowClockwise, ArrowLeft, Bed, Bell, CaretDown, Info, Megaphone, BookOpenText, Books, BowlFood, Brain, Briefcase,
  Bus, CalendarBlank, CalendarStar, CaretRight, ChartBar, ChartLineUp, ChatCircleDots,
  ChatCircleText, CheckCircle, Circle, ClipboardText, CreditCard, Desktop, DoorOpen,
  DownloadSimple, Eye, FileArrowUp, FileText, Funnel, Gavel, GearSix, GraduationCap,
  Handshake, HeartStraight, HouseLine, IdentificationBadge, Lightbulb, ListChecks,
  List, LockKey, MagnifyingGlass, Microphone, PaperPlaneRight, MapPinArea, Medal, Money, Package, PaperPlaneTilt, Plus,
  Pulse, Robot, Scan, ShieldCheck, SidebarSimple, SignOut, Sparkle, SpinnerGap, SquaresFour, Star,
  ThumbsUp, Ticket, Trash, Users, UsersThree, Wallet, WarningCircle, Wrench, X,
} from '@phosphor-icons/react';

const ICONS = {
  'arrow-clockwise': ArrowClockwise,
  'arrow-left': ArrowLeft,
  bed: Bed,
  bell: Bell,
  info: Info,
  megaphone: Megaphone,
  'book-open-text': BookOpenText,
  books: Books,
  'bowl-food': BowlFood,
  brain: Brain,
  briefcase: Briefcase,
  bus: Bus,
  calendar: CalendarBlank,
  'calendar-star': CalendarStar,
  'caret-down': CaretDown,
  'caret-right': CaretRight,
  'chart-bar': ChartBar,
  'chart-line-up': ChartLineUp,
  'chat-circle-dots': ChatCircleDots,
  'chat-circle-text': ChatCircleText,
  'check-circle': CheckCircle,
  'clipboard-text': ClipboardText,
  'credit-card': CreditCard,
  desktop: Desktop,
  'door-open': DoorOpen,
  download: DownloadSimple,
  eye: Eye,
  'file-arrow-up': FileArrowUp,
  'file-text': FileText,
  funnel: Funnel,
  gavel: Gavel,
  gear: GearSix,
  'graduation-cap': GraduationCap,
  handshake: Handshake,
  'heart-straight': HeartStraight,
  'house-line': HouseLine,
  'identification-badge': IdentificationBadge,
  lightbulb: Lightbulb,
  'list-checks': ListChecks,
  list: List,
  'lock-key': LockKey,
  'magnifying-glass': MagnifyingGlass,
  'map-pin-area': MapPinArea,
  medal: Medal,
  microphone: Microphone,
  money: Money,
  package: Package,
  'paper-plane': PaperPlaneTilt,
  'paper-plane-right': PaperPlaneRight,
  plus: Plus,
  pulse: Pulse,
  robot: Robot,
  scan: Scan,
  'shield-check': ShieldCheck,
  sidebar: SidebarSimple,
  'sign-out': SignOut,
  sparkle: Sparkle,
  spinner: SpinnerGap,
  'squares-four': SquaresFour,
  star: Star,
  'thumbs-up': ThumbsUp,
  ticket: Ticket,
  trash: Trash,
  users: Users,
  'users-three': UsersThree,
  wallet: Wallet,
  'warning-circle': WarningCircle,
  wrench: Wrench,
  x: X,
};

/** <Icon name="briefcase" />. Decorative unless `label` is given. */
export function Icon({ name, size = 16, label, spin = false, style }) {
  const C = ICONS[name] || Circle;
  return (
    <C
      size={size}
      weight="duotone"
      className={`eq-icon${spin ? ' eq-spin' : ''}`}
      style={style}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? 'img' : undefined}
    />
  );
}

export const ICON_NAMES = Object.keys(ICONS);

/** The Phosphor component for a design-system icon name, or null. */
export function iconComponent(name) {
  return ICONS[name] || null;
}
